import { render } from "./ColorInput.vue?vue&type=template&id=0aa51a44&scoped=true&ts=true"
import script from "./ColorInput.vue?vue&type=script&lang=ts"
export * from "./ColorInput.vue?vue&type=script&lang=ts"

import "./color-input.scss?vue&type=style&index=0&id=0aa51a44&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa51a44"]])

export default __exports__